<template>
    <div style="margin-top: 10px">
        
         <div class="validation-section">
            <div class="row">
                <div class="col-md-12">
                    <label>Ingrese el Número de Abonado</label>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <base-input v-model="model.NroAbonado"></base-input>
                </div>
            </div>
            <div class="row" style="text-align:right">
                <div class="col-md-12">
                    <base-button type="warning" size="lg" @click="validateArticle" style="margin: auto; margin-top: 10px">
                        <i class="fa fa-check fa-fw"></i> Validar
                    </base-button>
                </div>
            </div>
        </div>

        <div class="recarga-section">
            <div class="row">
                <div class="col-md-12">
                    <label>Cliente</label>
                    <br />
                    <base-input v-model="model.FullName" :disabled="true"></base-input>
                </div>     
            </div> 
             <div class="row">
            <div class="col-md-12">
                    <label>Pack</label>
                    <br />
                    <KitsCombo
                        v-model="model.SelectedValue"
                        v-bind:items="Packs"
                        propertyName="NombrePack"
                        propertyID="PropertyID"
                        :todos="true"
                        nullText=" -- Seleccione un Pack -- "
                        v-on:input="change">
                    </KitsCombo>
                </div> 
            </div>
            <div class="row">
                <div class="col-md-12">
                   <money-with-indicator v-model="model.Importe" v-on:blur="changeImport" v-on:validatedOK="onSaldoOK"/>
                </div>     
            </div> 
           
        </div>
    </div>
</template>

<script>
import axiosHelpers from "@/helpers/axiosHelpers";
import KitsCombo from "@/components/KitsCombo";
import notificationHelpers from "@/helpers/notificationHelpers";
import MoneyWithIndicator from '@/components/Custom/MoneyWithIndicator';

    export default {
        components: { KitsCombo, notificationHelpers,MoneyWithIndicator },
        props: {
                Aux1: "",
                Aux2: "",
                Aux3: "",
                Aux4: "",
                Importe: "",
                Validate: false,
                Errors: []
        },
        data() {
            return {
                model: {
                    NroAbonado:'',
                    FullName: '',
                    ClientID: '',
                    Aux1:'',
                    Aux2:'',
                    Importe:0,
                    Pack: null,
                    SelectedValue: null,
                    Validate: false,
                    Errors:[]
                },
                Packs: []
            }
        }, 
        mounted()
        {
                
            // let context = this;
            // context.model.NroAbonado = '';
            // context.model.FullName = '';
            // context.model.Pack = null;
            // context.model.SelectedValue = null;
            // context.model.Packs = null;
        },
      
        methods: {
            change(val){
                let context = this;
                if(isNaN(val)){
                    context.model.Aux1 = "";
                }
                else{
                    context.model.Pack = this.Packs.filter(x => x.PropertyID == val);
                    if(this.model.Pack != null && this.model.Pack != undefined)
                    {
                        context.model.Aux1 = context.model.Pack[0].Codigo;
                        context.model.Aux2 = context.model.Pack[0].Codigo;
                        context.model.Aux3 = context.model.NroAbonado;
                        context.model.Aux4 = context.model.Pack[0].NombrePack;
                    } 
                }
                this.validate();
                this.$emit('input', context.model);
            },
            changeImport(val){
                let context=this;
                 if(isNaN(this.model.Importe)){
                    context.model.Import = 0;
                }
                this.validate()
                this.$emit('input', context.model);
            },
            onSaldoOK(val) {
                this.$emit("saldoOK", val);
            },
            validateArticle()
            {
                let context = this;
                context.model.Errors = [];
                if(context.model.NroAbonado != "")
                {
                        var param = { Aux: context.model.NroAbonado,ArticleID:93 };
                        axiosHelpers.axiosGet(
                            "Recarga/ValidateArticle",
                            param,
                            context,
                            function(data) 
                            {
                                // -- Si valido OK
                                if(data.ResponseVM.Message!=null)
                                {
                                    context.model.Validate=true;
                                    var obj = JSON.parse(data.ResponseVM.Message)
                                     context.model.FullName = obj.Cliente;
                                     context.model.NroAbonado = obj.NroAbonado;
                                     var propertyID=1;

                                    obj.Packs.forEach(x => x.PropertyID=propertyID++);
                                    context.Packs =obj.Packs;
                                }
                                else
                                {
                                    context.model.Errors.push("No se pudo validar el Número de Abonado.");
                                }
                            }
                        );
                }
                else 
                {
                    context.model.Errors.push("El Número de Abonado debe tener un formato correcto."); 
                    notificationHelpers.showError("Error!", "El Número de Abonado debe tener un formato correcto.", context);
                }
            },
            validate() {
                let context = this;
                context.model.Errors = [];
                if (context.model.Aux1.length == 0) {
                    context.model.Validate = false;
                    context.model.Errors.push("Debe seleccionar un pack");
                } else if (context.model.Importe <= 0) {
                    context.model.Validate = false;
                    context.model.Errors.push("El importe no puede ser menor que 0");
                } else {
                    context.model.Validate = true;
                }
            }
        }
    }
</script>